<button mat-icon-button class="back-nav" (click)="goBack()" [disabled]="isPosRoute">
    <mat-icon [svgIcon]="'heroicons_solid:arrow-left'"></mat-icon>
</button>
